import Private from 'components/Private';
import { Navigate } from 'react-router-dom';
import { DashboardRoute, LoginRoute, OnboardingRoute, RenewMemberRoute, SignUpRoute } from 'routes';
import { isValidToken } from 'utils';

const NonAuth = ({ children }) => {
	const isAuth = isValidToken();

	return isAuth ? <Navigate to="/dashboard" /> : children;
};

export const getRoutes = () => {
	return [
		{
			path: '/signup',
			element: (
				<NonAuth>
					<SignUpRoute />
				</NonAuth>
			)
		},
		{
			path: '/login',
			element: (
				<NonAuth>
					<LoginRoute />
				</NonAuth>
			)
		},
		{
			path: '/',
			element: <Private />,
			children: [
				{ path: '/', index: true, element: <Navigate to="/dashboard" replace /> },
				{ path: '/dashboard', element: <DashboardRoute /> },
				{ path: '/onboarding', element: <OnboardingRoute /> },
				{ path: '/renew_member/:portal_id/:contact_id/', element: <RenewMemberRoute /> },
				{ path: '*', element: <Navigate to="/dashboard" replace /> }
			]
		}
	];
};
